var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid gap-5 w-4/5 grid-cols-2 mt-5"},_vm._l((_vm.items),function(item){return _c('InlineCard',{key:item.title,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }